import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
import Logo from '../images/Uptown-White-no-background-300x116.png'

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white box-shadow mb-3" light>
          <Container className="d-flex">
            <div className='d-flex flex-column'>
              <NavbarBrand tag={Link} to="/"><img className="logo" src={Logo} alt="PropertyFuze" style={{ marginTop: '-20px' }} /></NavbarBrand>
              <div style={{ marginRight: '18px', marginLeft: '18px', marginTop: '-24px' }}>
                <h6 style={{marginRight: '1rem'}} className='text-white'><div className='d-flex justify-content-between'>
                  <div>L</div>
                  <div>e</div>
                  <div>a</div>
                  <div>s</div>
                  <div>i</div>
                  <div>n</div>
                  <div>g</div>
                  <div>&nbsp;</div>
                  <div>V</div>
                  <div>e</div>
                  <div>l</div>
                  <div>o</div>
                  <div>c</div>
                  <div>i</div>
                  <div>t</div>
                  <div>y</div>
                </div></h6>
              </div>
            </div>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                {/* <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                </NavItem> */}
                <LoginMenu>
                </LoginMenu>
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}
